import React, { useCallback } from 'react'
import { IInvoice, ResultObjectType } from '@cbgms/api'
import { formatDateTime } from '@cbgms/base/utils/datetime'
import Currency from '@cbgms/components/general/Currency'
import { splitRegistration } from '@cbgms/base/utils/vehicle'
import DescriptionIcon from '@mui/icons-material/Description'
import { ResultTitle } from './Title'
import { Box, Grid, Typography } from '@mui/material'
import FullName from '@cbgms/components/src/utils/FullName'

export interface InvoiceResultType {
  Type: ResultObjectType
  Invoice: Partial<IInvoice>
  clearQuery: () => void
  primaryAction: () => Promise<void>
  hasGroupHeader: boolean
}

export const InvoiceResult: React.FC<InvoiceResultType> = props => {
  const { Invoice, Type, hasGroupHeader, primaryAction } = props
  const Registration = splitRegistration(Invoice.VehicleRegistration)

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      e.stopPropagation()
      primaryAction()
    },
    [primaryAction]
  )

  return (
    <Box sx={{ cursor: 'pointer', width: '100%' }} onClick={onClick}>
      <Grid container spacing={2}>
        <ResultTitle resultType={Type} isTitleVisible={!hasGroupHeader} />
        <Grid item xs={2}>
          <DescriptionIcon fontSize='large' />
        </Grid>
        <Grid item xs={10}>
          <Typography variant='body1' component='h3' style={{ fontWeight: 'bold' }}>
            {Invoice.InvoiceNumber} | {formatDateTime(Invoice.InvoiceDate)} | <Currency amount={Invoice.TotalVatIncluded} />
          </Typography>
          <Typography component='p'>
            {/* eslint-disable-next-line max-len */}
            <FullName firstName={Invoice?.CustomerFirstName || ''} lastName={Invoice?.CustomerName || ''} /> | {Registration.licensePlate} |{' '}
            {Invoice.VehicleManufacturer} {Invoice.VehicleModel} {Invoice.VehicleType}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  )
}
